/**
 * Takes an object and returns a string of its values, optionally filtered by specified fields in order.
 */
export function stringifyObjectValues(props: { obj: Record<string, any>; fields?: string[]; joiner?: string }): string {
  const { obj, fields, joiner = ', ' } = props
  if (!obj || typeof obj !== 'object') {
    return ''
  }
  const values = fields ? fields.map((k) => obj[k]).filter(Boolean) : Object.values(obj).filter(Boolean)
  return values.join(joiner)
}
